module.exports = __webpack_public_path__ + "static/media/11.d9ece89a.png";